var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import apiClient from '@utils/api-client';
import { apiInternalTerritoriesPath } from '../../routes';
const useGetTerritories = () => {
    const [territories, setTerritories] = useState([]);
    const [restricted, setRestricted] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    useEffect(() => {
        const controller = new AbortController();
        const fetchTerritories = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            try {
                const response = yield apiClient.get(apiInternalTerritoriesPath(), {
                    signal: controller.signal
                });
                setTerritories(response.data.data);
                setRestricted(response.data.restricted);
            }
            catch (err) {
                if (!controller.signal.aborted) {
                    setTerritories([]);
                    setError(err);
                }
            }
            finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        });
        void fetchTerritories();
        return () => {
            controller.abort();
        };
    }, []);
    return { territories, restricted, loading, error };
};
export default useGetTerritories;
